export default __webpack_public_path__ + "static/media/Homepage-EN.efcd1737.jpg";